module.exports = __webpack_public_path__ + "media/images/recruitment/landing/feature01-7ba97e953521824f2e48d49e1acfdf3c.svg";